// UD Garden — Contenido centralizado

export const siteConfig = {
  name: 'UD Garden',
  tagline: 'Mulch Decorativo · Hecho en Uruguay',
  description:
    'Mulch decorativo de eucalyptus y pino para jardines, parques y proyectos de paisajismo sustentable en Uruguay.',
  url: 'https://www.udgarden.uy',
  ogImage: 'https://www.udgarden.uy/og-image.webp',
  phone: '+598 94 123 035',
  email: 'udgarden.uy@gmail.com',
  address: 'Montevideo, Uruguay',
  instagram: 'https://www.instagram.com/udgarden.uy/',
  whatsapp: 'https://wa.me/59894123035',
  mercadolibre: 'https://tienda.mercadolibre.com.uy/udgarden',
}

// Fee fijo de "envío a domicilio" — solo para mostrarlo en la UI (checkout y
// admin). El monto que efectivamente se cobra vía MercadoPago vive
// hardcodeado en supabase/functions/create-preference/index.ts — mantener
// sincronizados hasta que se centralice en una configuración real.
export const ENVIO_DOMICILIO_FEE = 380

export const navLinks = [
  { label: 'Productos',    href: '#productos'       },
  { label: 'Calculadora',  href: '#calculadora'     },
  { label: 'Educación',    href: '#consejo-del-mes' },
  { label: 'Blog',         href: '#blog'            },
  { label: 'Nosotros',     href: '#sobre-nosotros'  },
  { label: 'Trabajos',      href: '#trabajos'        },
  { label: 'Preguntas',    href: '#faq'             },
  { label: 'Contacto',     href: '#contacto'     },
]

export const heroContent = {
  kicker: 'Paisajismo sustentable · Uruguay',
  title: 'UD\nGARDEN',
  subtitle:
    'Mulch para jardinería y paisajismo que protege el suelo, conserva la humedad, facilita el mantenimiento y realza tu jardín.',
  ctaPrimary:   { label: 'Ver productos',     href: '#productos' },
  ctaSecondary: { label: 'Quiénes somos', href: '#sobre-nosotros' },
  stats: [
    { value: '+500', label: 'proyectos'    },
    { value: '10+',  label: 'años'         },
    { value: '100%', label: 'biodegradable' },
  ],
}
